import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import moment from "moment";
import { memo, useCallback } from "react";

type Props = {
  startDate: moment.Moment;
  endDate: moment.Moment;
  selectedView?: "list" | "calendar";
  setSelectedView?: (view: "list" | "calendar") => void;
  goToNextWeek: () => void;
  goToPrevWeek: () => void;
  goToThisWeek: () => void;
  isFetching?: boolean;
};

const InterviewHeader = ({
  startDate,
  endDate,
  selectedView,
  setSelectedView,
  goToNextWeek,
  goToPrevWeek,
  goToThisWeek,
  isFetching,
}: Props) => {
  const handleViewChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (setSelectedView) {
        setSelectedView(event.target.value as "list" | "calendar");
      }
    },
    [setSelectedView],
  );
  return (
    <Grid container justifyContent={"space-between"}>
      <Grid container gap={2} alignItems={"center"} item xs={6}>
        <IconButton onClick={goToPrevWeek}>
          <NavigateBefore></NavigateBefore>
        </IconButton>
        <Typography variant="body1">
          {`${moment(startDate).format("MM-DD-yyyy")} to ${moment(endDate).format("MM-DD-yyyy")}`}
        </Typography>
        <IconButton onClick={goToNextWeek}>
          <NavigateNext></NavigateNext>
        </IconButton>
        {moment().isBetween(startDate, endDate, null, "[]") ? null : (
          <Button variant={"outlined"} onClick={goToThisWeek}>
            Go to current week
          </Button>
        )}
        {isFetching && (
          <>
            <Typography variant="body1" color="textSecondary">
              Loading...
            </Typography>
            <CircularProgress size={24} sx={{ ml: 2 }} />
          </>
        )}
      </Grid>
      <Grid
        container
        item
        gap={2}
        xs={6}
        justifyContent={"flex-end"}
        alignItems={"center"}
      >
        <RadioGroup
          row
          sx={{ ml: 2 }}
          value={selectedView}
          onChange={handleViewChange}
        >
          <FormControlLabel
            value="calendar"
            control={<Radio />}
            label="Calendar View"
          />
          <FormControlLabel
            value="list"
            control={<Radio />}
            label="List View"
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default memo(InterviewHeader);
